import auth from "./auth";
import myAccount from "./my-account";
import bookAppointments from "./book-appointments";
import manageAppointments from "./manage-appointments";
import publicForms from "./public-forms";

export const Features = [
    auth,
    myAccount,
    bookAppointments,
    manageAppointments,
    publicForms,
];

export default Features;
